import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  filters: {
    formData: {
      l1: [],
      l2: [],
      l3: [],
      country: [],
    },
    searchString: '',
  },
  previouslySelectedRow : null,
}

export const filtersSlice = createSlice({
  name: 'should-cost-filters',
  initialState,
  reducers: {
    setShouldCostFilters: (state, action) => {
      state.filters = action.payload
    },
    resetShouldCostFilters: () => initialState,
    setPreviouslySelectedRow: (state, action) =>{
      state.previouslySelectedRow = action.payload
    },
  },
})

export const { setShouldCostFilters, resetShouldCostFilters,setPreviouslySelectedRow } = filtersSlice.actions

export default filtersSlice.reducer
